module.exports = __webpack_public_path__ + "44dc75e88584b14df825909a08f8de43.svg";